export default class {
    constructor ($q, $translate, papaparse, toastr, lodash,
                 QUESTIONS_FIELDS_FREE_TEXT_ENUM, QUESTIONS_FIELDS_OTHER_ENUM, QUESTIONS_TYPE_ENUM,
                 QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM, MetaFieldResource) {
        this.$q = $q;
        this.$translate = $translate;
        this.papaparse = papaparse;
        this.toastr = toastr;
        this.lodash = lodash;
        this.QUESTIONS_FIELDS_FREE_TEXT_ENUM = QUESTIONS_FIELDS_FREE_TEXT_ENUM;
        this.QUESTIONS_FIELDS_OTHER_ENUM = QUESTIONS_FIELDS_OTHER_ENUM;
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
        this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM = QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM;
        this.MetaFieldResource = MetaFieldResource;

        this.delimitter = '';
        this.encoding = '';
        this.language = '';
        this.questionPoolId = null;
        this.importableFields = null;
    }

    setDelimitter (delimitter) {
        this.delimitter = delimitter;
    }

    setLanguage (language) {
        this.language = language;
    }

    setQuestionType (questionType) {
        this.questionType = questionType;
        this.importableFields = null; // if type will be changed we need different fields to select from
    }

    setEncoding (encoding) {
        this.encoding = encoding;
    }

    setQuestionPoolId (questionPoolId) {
        this.questionPoolId = questionPoolId;
    }

    setCompanyMetaFields () {
        if (!this.companyMetaFields) {
            this.MetaFieldResource.query({ pageSize: 0 }).$promise.then((response) => {
                this.companyMetaFields = this.lodash.reduce(response, (origin, metaField) => {
                    origin[metaField.id] = metaField.name;
                    return origin;
                }, {});
            });
        }
    }

    getImportableFields () {
        if (!this.importableFields) {
            if (this.questionType === this.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT) {
                this.questionFields = this.QUESTIONS_FIELDS_FREE_TEXT_ENUM.LABELS;
            }
            else {
                this.questionFields = this.QUESTIONS_FIELDS_OTHER_ENUM.LABELS;
            }

            // All the fields that will be used
            this.importableFieldsToBeSorted = this.lodash.assign({}, this.questionFields, this.companyMetaFields);

            // Prepare fields for easy sort
            this.importableFieldsToSort = this.lodash.reduce(this.importableFieldsToBeSorted, (origin, item, key) => {
                origin.push({ item, key });
                return origin;
            }, []);

            // Sort fields ASC by the label
            this.importableFields = this.lodash.orderBy(this.importableFieldsToSort, ['item']);
        }

        return this.importableFields;
    }

    getParsedCsvFile () {
        return this.parsedCsvFile;
    }

    getParsedCsvMeta () {
        return this.parsedCsvMeta;
    }

    /**
     * Not sure that this is the best way, but this is what
     * 1) selects the needed fields
     * 2) pairs values with designated field in database
     * 3) returns normalized data to send to server
     */
    getFormattedImportData () {
        const inUseFields = this.organizeForm.useInImport.map((item, key) => {
            if (item === true) {
                return this.organizeForm.field[key];
            }
            return undefined;
        });

        const data = this.parsedCsvFile.map((item) => {
            let answerCounter = 0;
            const i18n = {};
            const formattedRow = { questionAnswers: [], questionI18ns: {}, points: 0, answerFeedbacks: [] };

            angular.forEach(inUseFields, (value, key) => {
                // FIXME :: this looks bit crap
                if (value) {
                    // Do not send answers with empty value
                    if (value === this.QUESTIONS_FIELDS_OTHER_ENUM.KEYS.ANSWER && item[key]) {
                        const answerData = {
                            sequence: answerCounter,
                            translations: {},
                            correctness: this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM.KEYS.INCORRECT,
                            points: -1
                        };
                        answerData.translations[this.language] = { text: item[key] };
                        formattedRow.questionAnswers.push(answerData);
                        answerCounter = answerCounter + 1;
                    }
                    else if (value === this.QUESTIONS_FIELDS_OTHER_ENUM.KEYS.ANSWER_FEEDBACK) {
                        formattedRow.answerFeedbacks.push(item[key]);
                    }
                    else if (value === this.QUESTIONS_FIELDS_OTHER_ENUM.KEYS.LEVEL) {
                        formattedRow[value.toLowerCase()] = item[key].toUpperCase();
                    }
                    else if (value === this.QUESTIONS_FIELDS_OTHER_ENUM.KEYS.CATEGORY) {
                        formattedRow[value.toLowerCase()] = item[key];
                    }
                    else if (value === this.QUESTIONS_FIELDS_OTHER_ENUM.KEYS.EXTERNAL_ID) {
                        formattedRow[this.QUESTIONS_FIELDS_OTHER_ENUM.API_FIELD[value]] = item[key];
                    }
                    else if (this.isI18nField(value)) {
                        i18n[value.toLowerCase()] = item[key];
                    }
                    else if (this.companyMetaFields[value]) {
                        if (!formattedRow.metaFields) {
                            formattedRow.metaFields = {};
                        }
                        formattedRow.metaFields[value] = { value: item[key], language: this.language };
                    }
                    else {
                        formattedRow[value.toLowerCase()] = item[key];
                    }
                }
            });

            angular.forEach(formattedRow.answerFeedbacks, (value, key) => {
                formattedRow.questionAnswers[key].translations[this.language].feedback = value;
            });

            formattedRow.formId = this.organizeForm.formId;
            formattedRow.questionPoolId = this.questionPoolId;
            formattedRow.questionI18ns[this.language] = i18n;
            formattedRow.type = this.questionType;
            formattedRow.language = this.language; // pass language to api for easier use with category search

            let correctAnswerNumbers = [];
            let correctAnswerPoints = [];

            if (this.questionType === this.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX) {
                correctAnswerNumbers = formattedRow.correct_answer_nr.split(',').map((answerNr) => {
                    return parseInt(answerNr.trim(), 10) - 1;
                });
                correctAnswerPoints = formattedRow.points.split(',').map((point) => {
                    return point.trim();
                });
            }
            else {
                correctAnswerNumbers.push(formattedRow.correct_answer_nr - 1);
                correctAnswerPoints.push(formattedRow.points);
            }

            // mark the right answer
            correctAnswerNumbers.forEach((answerNumber, index) => {
                if (answerNumber >= 0 && formattedRow.questionAnswers[answerNumber]) {
                    formattedRow.questionAnswers[answerNumber].correctness = this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM.KEYS.CORRECT;
                    formattedRow.questionAnswers[answerNumber].points = correctAnswerPoints[index];
                }
            });

            if (this.questionType === this.QUESTIONS_TYPE_ENUM.KEYS.RADIO && (formattedRow.correct_answer_nr - 1) > formattedRow.questionAnswers.length) {
                this.toastr.error(this.$translate.instant('question.Correct answer number is bigger than answers count'));
            }

            if (this.questionType === this.QUESTIONS_TYPE_ENUM.KEYS.RADIO && formattedRow.correct_answer_nr > formattedRow.questionAnswers.length) {
                this.toastr.error(this.$translate.instant('question.Correct answer number is bigger than answers count'));
            }

            if (this.questionType === this.QUESTIONS_TYPE_ENUM.KEYS.RADIO && !formattedRow.correct_answer_nr) {
                this.toastr.error(this.$translate.instant('question.Correct answer number is not set'));
            }

            if (this.questionType === this.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT) {
                delete formattedRow.questionAnswers; // No answers can be sent when type is FREE TEXT
            }
            return formattedRow;
        });
        data.splice(0, 1); // remove header
        return data;
    }

    getRequiredFields () {
        if (this.questionType === this.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT) {
            return [
                this.QUESTIONS_FIELDS_OTHER_ENUM.KEYS.NAME,
                this.QUESTIONS_FIELDS_OTHER_ENUM.KEYS.EXTERNAL_ID
            ];
        }
        return [
            this.QUESTIONS_FIELDS_OTHER_ENUM.KEYS.NAME,
            this.QUESTIONS_FIELDS_OTHER_ENUM.KEYS.EXTERNAL_ID,
            this.QUESTIONS_FIELDS_OTHER_ENUM.KEYS.ANSWER,
            this.QUESTIONS_FIELDS_OTHER_ENUM.KEYS.CORRECT_ANSWER_NR
        ];
    }

    isI18nField (field) {
        return this.lodash.includes([
            this.QUESTIONS_FIELDS_OTHER_ENUM.KEYS.NAME,
            this.QUESTIONS_FIELDS_OTHER_ENUM.KEYS.DESCRIPTION,
            this.QUESTIONS_FIELDS_OTHER_ENUM.KEYS.HINT
        ], field);
    }

    parse (file) {
        return this.parseCsvFile(file).then((results) => {
            this.parsedCsvFile = results.data.filter((item) => item.length === results.data[0].length);
            this.parsedCsvMeta = results.meta;
        });
    }

    parseCsvFile (file) {
        const deferred = this.$q.defer();
        const parse = (complete, error) => {
            this.papaparse.parse(file, {
                delimiter: this.delimitter,	// auto-detect
                encoding: this.encoding,
                complete,
                error
            });
        };
        parse(deferred.resolve, deferred.reject);
        return deferred.promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/question/import/index.js